export default {
    belongsToUser: null,
    settings: {
        caption: {
            en: 'New Report',
            de: 'Neuer Report'
        },
        description: {
            en: 'This Report is only for you!',
            de: 'Dieser Report ist nur für dich!'
        },
        showBorders: true,
        showColumnGrandTotals: true,
        showRowGrandTotals: true,
        showRowTotals: false,
        showColumnTotals: false,
        rtlEnabled: false,
        isFieldChooserEnabled: false,
        isExcelExportEnabled: false,
        excelExportFileName: 'Export'
    },
    fields: [],
    rowExpandedPaths: [],
    columnExpandedPaths: []
}